import React, { useState, useContext, useCallback } from 'react';
import styled from 'styled-components';
import cx from 'classnames';

import { ProgressBar, LoadingSpinner, Button } from '../../components/_shared';
import AccountLayout from '../../components/layout/Account';
import { AppContext } from '../../providers/AppProvider';
import './Progress.scss';

const Curriculum = styled.div.attrs({
  className:
    'bg-white rounded-xl px-9 py-8 flex flex-col sm:px-4 sm:py-7 sm:pb-0',
})`
  ${(props) =>
    props.isCore &&
    `
  `}
`;

const Progress = () => {
  const [selectedCurriculum, setSelectedCurriculum] = useState(null);
  const {
    loading,
    progress,
    endorsements,
    coreCurriculum,
    onContinueCourse,
  } = useContext(AppContext);

  const handleToggleCurriculum = (id) => () => {
    if (selectedCurriculum === id) {
      setSelectedCurriculum(null);
      return;
    }

    setSelectedCurriculum(id);
  };

  // if (loading) {
  //   return (
  //     <AccountLayout>
  //       <div className="w-full h-48 m-auto max-w-6xl flex items-center justify-center">
  //         <LoadingSpinner />
  //       </div>
  //     </AccountLayout>
  //   );
  // }

  const coursePercent = useCallback(
    (course) => {
      const userCourse = progress.find(
        ({ course: coourse }) => coourse && coourse._id === course._id
      );

      if (userCourse) {
        const total =
          userCourse.course.lessons.length + userCourse.course.quizzes.length;
        const current =
          userCourse.completedLessons.length +
          userCourse.completedQuizzes.length;
        return Math.min(100, (current / total) * 100);
      } else {
        return 0;
      }
    },
    [progress]
  );

  const renderCurriculum = ({ isCore, id, title, courses, ...rest }) => {
    const totalPercents = courses.reduce((p, c) => {
      const userCourse = progress.find(
        ({ course: coourse }) => coourse && coourse._id === c._id
      );

      if (userCourse) {
        const total =
          userCourse.course.lessons.length + userCourse.course.quizzes.length;
        const current =
          userCourse.completedLessons.length +
          userCourse.completedQuizzes.length;
        return p + Math.min(100, (current / total) * 100);
      } else {
        return p;
      }
    }, 0);

    const totalPercent = Math.floor(parseFloat(totalPercents / courses.length));

    return (
      <div className="flex flex-col mb-2 sm:mb-4" key={id}>
        <Curriculum isCore={isCore}>
          <div
            className={cx(
              'w-1/  3 text-regular text-primary mb-2 font-bold sm:w-full'
            )}
          >
            {title}
            <span className="text-primary ml-2 font-bold">
              ({totalPercent}%)
            </span>
          </div>
          <div className="flex-grow text-gray-200 text-sm mb-2">
            {/* {completedCourses} of {courses.length} Completed */}
          </div>
          <div className="w-full">
            <ProgressBar value={totalPercent} height={4} />
          </div>
          <div className="flex justify-between w-full">
            <Button
              type="flat"
              className={`mt-4 py-1 border border-solid text-primary text-base bg-transparent border-white`}
              caption="Continue"
              onClick={onContinueCourse(id)}
            />
            <Button
              type="flat"
              className={`mt-4 py-1 border border-solid text-primary text-base bg-transparent border-white`}
              caption={
                selectedCurriculum === id ? 'Hide Courses' : 'Show Courses'
              }
              onClick={handleToggleCurriculum(id)}
            />
          </div>
        </Curriculum>
        {selectedCurriculum === id && (
          <div className="p-9 bg-white rounded-xl mt-3 sm:px-4 sm:py-5">
            {courses
              .sort((a, b) => (a.no > b.no ? 1 : -1))
              .map((course, id) => (
                <div
                  key={course._id}
                  className="course-row flex flex-col justify-between mb-4"
                >
                  <div className="course-title mb-2 font-bold sm:text-regular">
                    Course {id + 1}. {course.title}
                  </div>
                  <div className="flex items-center">
                    <div className="flex-grow mr-4">
                      <ProgressBar
                        value={Number(Math.ceil(coursePercent(course)))}
                        height={4}
                      />
                    </div>
                    <div className="course-status text-center text-primary sm:text-sm">
                      {Number(Math.ceil(coursePercent(course)))}%
                    </div>
                  </div>
                </div>
              ))}
          </div>
        )}
      </div>
    );
  };

  // if (loading) {
  //   return (
  //     <div className="w-full h-full m-auto max-w-6xl flex items-center justify-center">
  //       <LoadingSpinner />
  //     </div>
  //   );
  // }

  return (
    <AccountLayout>
      <div className="text-lg font-semibold uppercase text-black tracking-widest mb-5 sm:text-xl sm:font-normal">
        Program progress
      </div>

      <div className="flex flex-col">
        {[coreCurriculum, ...endorsements].map(
          (curriculum, id) =>
            curriculum &&
            renderCurriculum({
              ...curriculum,
              courses: curriculum.courses.map(
                ({ description, ...other }, id) => ({
                  ...other,
                  no: curriculum.courseNos[id],
                })
              ),
            })
        )}
      </div>
    </AccountLayout>
  );
};

export default Progress;
